import {Injectable} from "@angular/core";
import {LogEvent} from "../enums/log-event";
import {LoggerService} from "./logger.service";
import {ZOID_APPS} from "../constants/zoid-apps";
import {ZoidApp} from "@core/interfaces/zoid-app";
import {environment} from "@env";
import {ChatTreeService} from "@core/services/chat-tree.service";
import {UserService} from "@core/services/user.service";

@Injectable({providedIn: 'root'})
export class ZoidAppsService {
  private _apps = ZOID_APPS;
  private _appsFromChatTree: ZoidApp[] | undefined = undefined;
  constructor(private logger: LoggerService, private chatTreeService: ChatTreeService, private userService: UserService) {
  }
  get apps() {
    return this.getAllApps();
  }

  async getChatTreeApps() {
    try {
      if (this._appsFromChatTree === undefined) {
        const chatTreeApps = await this.chatTreeService.installedAppsByParameters(this.userService.getCurrentUser()?.companiesIds || [], true);
        this._appsFromChatTree = chatTreeApps.map((app: any) => ({
          ...app,
          includeInAppBar: true,
          size: {
            width: app.iframeWidth || 320,
          },
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          url: environment.appsUrl[app.name] || app.url,
          tooltipKey: app.appTitle,
          id: app.liveChatAppId
        }));
      }
    } catch (error: any) {
      this.logger.error(LogEvent.LIVECHAT_LOAD_ASKSTORE_APP_ERROR, error);
    }

    return this.getAllApps();
  }

  getApp(appName: string) {
    const app = this.getAllApps().find(app => app.name === appName);
    if (!app) {
      this.logger.error(LogEvent.LIVECHAT_OPEN_APP_ERROR, new Error(`App not found: ${appName}`))
    }

    return app!
  }

  private getAllApps(): ZoidApp[] {
    return [...this._apps,...(this._appsFromChatTree || [])];
  }
}
